import { Component, Element, h, Host, Prop } from '@stencil/core';

import { getLoginUrl } from './unifiedLoginHelper';

@Component({
  tag: 'pn-marketweb-siteheader-login-button',
  styleUrl: 'pn-marketweb-siteheader-login-button.scss',
})
export class PnMarketwebSiteheaderLoginButton {
  @Element() hostElement: HTMLElement;
  @Prop() label: string = 'Log in';
  @Prop() useMarketwebLogin: boolean = false;
  @Prop() environment: string = 'local';
  
  loginUrl: string;

  componentWillLoad() {
    this.loginUrl = getLoginUrl(this.useMarketwebLogin, this.environment);
  }

  nagivateToLoginUrl() {
    const navigationUrl = `${this.loginUrl}${encodeURIComponent(window.location.href)}`;
    return navigationUrl;
  }

  render() {
    return (
      <Host>
        <pn-button href={this.nagivateToLoginUrl()}>{this.label}</pn-button>
      </Host>
    );
  }
}
